import React, { Component } from 'react'
import Radium from 'radium'
import Link from 'gatsby-link'
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import { FORM_STYLES } from '../components/assets/forms-shared'
import { BTN_STYLES } from '../components/assets/btns-shared'
import Palette from '../components/assets/palette'
import { Helmet } from 'react-helmet'
import Scrollspy from 'react-scrollspy'
import MobileDetect from 'mobile-detect'
import Sticky from 'react-stickynode'
import { HaikuMiniIconSVG, FacebookSVG, TwitterSVG, SlackSVG } from '../components/assets/icons'
import scrollToComponent from 'react-scroll-to-component';

const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : {mobile: () => { return false }}
const isMobile = md.mobile()

const STYLES = {
  contentWrap: {
    maxWidth: 1440,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 80,
    marginBottom: 30
  },
  featuresNavWrap: {
    width: 320,
    height: '100%',
    marginLeft: 50,
    marginRight: 100,
  },
  featuresContentWrap: {
    width: '70%',
    height: '100%',
    paddingRight: 60,
    '@media screen and (max-width: 1115px)': {
      width: '90%',
      paddingLeft: 10,
      paddingRight: 10
    },
  },
  link: {
    color: Palette.LIGHTEST_BLUE,
    textDecoration: 'none'
  },
  sideNavigationWrap :{
    paddingTop: 35
  },
  sideNavigation: {
    paddingLeft: 0,
    marginTop: 20,
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
    backgroundColor: Palette.COAL
  },
  sideNavigationLink: {
    width: 'auto',
    display: 'block',
    height: '100%',
    padding: '1em 1em 1em 25px',
    textTransform: 'uppercase',
    textDecoration: 'none'
  },
  sideNavigationTitle: {
    backgroundColor: Palette.COAL,
    color: Palette.SUNSTONE,
    paddingTop: 10,
    paddingLeft: 25,
    paddingBottom: 5
  },
  pageSection: {
    paddingTop: 35,
    marginBottom: 140
  },
  featureImage: {
    minHeight: 180,
    marginBottom: 20,
    borderRadius: 8,
    objectPosition: 'left top',
    objectFit: 'cover',
    border: '1px solid #232d30'
  },
  mobileTitleSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    color: Palette.ROCK,
    fontSize: 32,
    marginTop: -100,
    marginBottom: -10,
    '@media screen and (min-width: 700px)': {
      display: 'none',
    },
  },
  mobileTitle: {
    fontSize: 32,
    marginLeft: 10,
    marginBottom: 50
  },
  h3: {
    color: Palette.SUNSTONE,
    fontSize: 37,
    letterSpacing: .5,
    lineHeight: '40px',
    wordWrap: 'break-word',
    fontFamily: 'brandon-grotesque',
    textTransform: 'uppercase',
    paddingTop: 15,
    margin: '0 0 12px'
  },
  subtitle: {
    color: '#d7e1e2',
    fontSize: 20,
    marginTop: 5,
    fontWeight: 300,
    lineHeight: '33px',
  },
  hideOnMobile: {
    '@media screen and (max-width: 700px)': {
      display: 'none'
    }
  },
  hideOnTablet: {
    '@media screen and (max-width: 1115px)': {
      display: 'none'
    }
  },
  ...FORM_STYLES,
  ...BTN_STYLES
}

class Features extends Component {
  constructor() {
    super()

    this.state = {}
  }

  componentDidMount() {
    if (this.props.location.hash) {
      scrollToComponent(this[this.props.location.hash.substr(1)], { align: 'top' });
    }
  }

  render() {
    return (
    <div>
      <style>
          {`
             .isCurrent {
               background-color: ${Palette.FATHER_COAL};
               color: ${Palette.SUNSTONE}
             }
          `}
       </style>

      <Helmet>
        <title>Features | Haiku</title>
        <meta name="description" content="Learn more about features like Haiku for Mac, Timeline, Interactivity, Sketch, Figma & SVG Support, Shared version history, Haiku Core, Haiku CLI, Cross Platform, Haiku for Teams, Layouts & Components." />
        <meta property="og:title" content="Features | Haiku" />
        <meta property="og:description" content="Learn more about features like Haiku for Mac, Timeline, Interactivity, Sketch, Figma & SVG Support, Shared version history, Haiku Core, Haiku CLI, Cross Platform, Haiku for Teams, Layouts & Components." />
      </Helmet>

      <Navbar location="features" />

      <div style={{
        margin: '0 auto',
        width: '100%',
        maxWidth: 1440
      }}>
        <div id="stickyTarget">
          <div style={STYLES.contentWrap}>
            <div style={[STYLES.featuresNavWrap, STYLES.hideOnTablet]}>
              <Sticky bottomBoundary='#stickyTarget'>
                <div style={STYLES.sideNavigationWrap}>
                  <Scrollspy style={STYLES.sideNavigation} items={ ['features', 'haikuForMac', 'timeline', 'interactivity', 'drawing', 'sharedVersionHistory', 'haikuCore', 'haikuCli', 'crossPlatform', 'haikuForTeams', 'layoutsComponents', 'drawingTools'] } currentClassName="isCurrent">
                    <div style={STYLES.sideNavigationTitle}><h1 style={{fontSize: 32, marginTop: 0, marginBottom: 0}}>Features</h1></div>
                    <a style={STYLES.sideNavigationLink} href="#haikuForMac">Haiku for Mac</a>
                    <a style={STYLES.sideNavigationLink} href="#timeline">Timeline</a>
                    <a style={STYLES.sideNavigationLink} href="#interactivity">Interactivity</a>
                    <a style={STYLES.sideNavigationLink} href="#drawing">Sketch, Figma, Ai & SVG</a>
                    <a style={STYLES.sideNavigationLink} href="#sharedVersionHistory">Shared Version History</a>
                    <a style={STYLES.sideNavigationLink} href="#haikuCore">Haiku Core</a>
                    <a style={STYLES.sideNavigationLink} href="#haikuCli">Haiku CLI</a>
                    <a style={STYLES.sideNavigationLink} href="#crossPlatform">Cross Platform</a>
                    <a style={STYLES.sideNavigationLink} href="#haikuForTeams">Haiku for Teams</a>
                    <a style={STYLES.sideNavigationLink} href="#layoutsComponents">Layouts & Components</a>
                  </Scrollspy>
                </div>
              </Sticky>
            </div>
            <div style={STYLES.featuresContentWrap}>
              <section style={[STYLES.pageSection, STYLES.mobileTitleSection]}>
                <HaikuMiniIconSVG color={Palette.ROCK}/>
                <h2 style={STYLES.mobileTitle}>Features</h2>
              </section>
              <section id="haikuForMac" style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/haiku-for-mac.jpg")} alt="Library and Stage in Haiku for Mac"/>
                  <h3 style={STYLES.h3}>Haiku for Mac</h3>
                  <h4 style={STYLES.subtitle}><em>Coming soon to Windows</em></h4>
                  <p style={STYLES.subtitle}>Haiku for Mac is our desktop design environment. Think of it as a design portal to your team's codebase. Use it to author UI components and even iterate on your components after they're integrated with your app or website.</p>
                  <a href={`${process.env.ACCOUNT_SITE_URL}/new`}>
                    <div key='cta4' style={[
                      STYLES.btn,
                      STYLES.cta,
                      { display: 'inline-block' },
                      isMobile ? {padding: '14px 24px 13px', width: 'inherit'} : undefined
                    ]}>
                      Get Haiku Free
                    </div>
                  </a>
              </section>
              <section id="timeline" ref={(el) => this.timeline = el} style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/timeline.jpg")} alt="Timeline in Haiku for Mac"/>
                  <h3 style={STYLES.h3}>Timeline</h3>
                  <p style={STYLES.subtitle}>With Timeline, choreograph animations in your designs visually. Sequence and animate elements using the built-in tween and easing curve library.</p>
                  <p style={STYLES.subtitle}><a href="https://docs.haiku.ai/using-haiku/creating-an-animation.html">Learn how to create animations with the Timeline &raquo;</a></p>
              </section>
              <section id="interactivity" ref={(el) => this.interactivity = el} style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/interactivity.jpg")} alt="Interactivity in Haiku for Mac"/>
                  <h3 style={STYLES.h3}>Interactivity</h3>
                  <p style={STYLES.subtitle}>Add interactivity to your designs with Haiku's easy-to-use, beginner-friendly scripting tools, powered by JavaScript:</p>
                  <p style={STYLES.subtitle}><a href="https://docs.haiku.ai/using-haiku/writing-expressions.html"><strong>Expressions</strong></a> are tiny code snippets — like spreadsheet formulas — that bring dynamic behavior to your animations.</p>
                  <p style={STYLES.subtitle}><a href="https://docs.haiku.ai/using-haiku/defining-states.html"><strong>States</strong></a> are collections of internal data that you can summon using expressions.</p>
                  <p style={STYLES.subtitle}><a href="https://docs.haiku.ai/using-haiku/actions.html"><strong>Actions</strong></a> are small scripts that run in response to events — such as mouse clicks and other user input.</p>
              </section>
              <section id="drawing" ref={(el) => this.drawing = el} style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/sketch-svg.jpg")} alt="Sketch & SVG support in Haiku for Mac"/>
                  <h3 style={STYLES.h3}>Sketch, Figma, Adobe Illustrator & SVG support</h3>
                  <p style={STYLES.subtitle}>It's hard to know where to get started with a new tool, which is why Haiku integrates with the tools you already love. Import a Sketch, Figma, Adobe Illustrator, or SVG file to start, and have at it.</p>
                  <p style={STYLES.subtitle}><a href="https://docs.haiku.ai/using-haiku/sketch-and-image-assets.html">Learn more about importing design files &raquo;</a></p>
              </section>
              <section id="sharedVersionHistory" ref={(el) => this.sharedVersionHistory = el} style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/shared-version-history.jpg")} alt="Version History in Haiku for Mac"/>
                  <h3 style={STYLES.h3}>Shared version history</h3>
                  <p style={STYLES.subtitle}>Every change, be it design or code, is backed by Haiku version control. Harness the power of git to version components, restore backups, and experiment with different designs using branches.</p>
              </section>
              <section id="haikuCore" ref={(el) => this.haikuCore = el} style={STYLES.pageSection}>
                <img style={[STYLES.featureImage, {objectPosition: 'center'}]} src={require("./features/haiku-core.jpg")} alt="Haiku Core"/>
                  <h3 style={STYLES.h3}>Haiku Core</h3>
                  <p style={STYLES.subtitle}>Haiku's design-as-code file format and a standards-based renderer power your animations in production. Out of the box, Haiku works with with vanilla web codebases, React, Angular, and Vue. Haiku Core is open source under the MIT license.</p>
                  <div key='cta3' style={[
                    STYLES.btn,
                    STYLES.cta,
                    { display: 'inline-block' },
                    isMobile ? {padding: '14px 24px 13px'} : undefined
                  ]}
                  onMouseEnter={() => haiku.haiGitub && haiku.haiGitub.getDefaultTimeline().gotoAndPlay(0)}>
                    <a style={{color: Palette.SUNSTONE, wordWrap: 'break-word'}} href="https://github.com/HaikuTeam/core" target="_blank">HAIKU CORE ON GITHUB</a>
                  </div>
              </section>
              <section id="haikuCli" ref={(el) => this.haikuCli = el}  style={STYLES.pageSection}>
                  <img style={STYLES.featureImage} src={require("./features/haiku-cli.jpg")} alt="Haiku CLI"/>
                  <h3 style={STYLES.h3}>Haiku CLI</h3>
                  <p style={STYLES.subtitle}>Haiku CLI is the swiss army knife for developers using Haiku. Use it to perform advanced tasks and get the most out of Haiku.</p>
                  <p style={STYLES.subtitle}><a href="https://github.com/HaikuTeam/cli">Learn more about the Haiku CLI &raquo;</a></p>
              </section>
              <section id="crossPlatform" ref={(el) => this.crossPlatform = el} style={STYLES.pageSection}>
                  <img style={[STYLES.featureImage, {objectPosition: 'center', objectFit: 'contain'}]} src={require("./features/cross-platform.png")} alt="Cross Platform support in Haiku"/>
                  <h3 style={STYLES.h3}>Cross Platform</h3>
                  <p style={STYLES.subtitle}>Design once, embed anywhere. Haiku components work with:</p>
                  <p style={STYLES.subtitle}><strong>All major browsers:</strong> Chrome, Firefox, Safari, and Edge.</p>
                  <p style={STYLES.subtitle}><strong>iOS & Android:</strong> Rendering powered by Lottie.</p>
                  <p style={STYLES.subtitle}><strong>JavaScript libraries:</strong> Integrate with any vanilla web project, or use native adapters for React, Vue, and Angular.</p>
              </section>
              <section id="haikuForTeams" ref={(el) => this.haikuForTeams = el} style={STYLES.pageSection}>
                  <h3 style={STYLES.h3}>Haiku for Teams</h3>
                  <h4 style={STYLES.subtitle}><em>Coming soon</em></h4>
                  <p style={STYLES.subtitle}>Collaborate across product teams with comments, multi-user collaboration and shared, visual version histories.</p>
              </section>
              <section id="layoutsComponents" ref={(el) => this.layoutsComponents = el} style={STYLES.pageSection}>
                  <h3 style={STYLES.h3}>Layouts & Components</h3>
                  <h4 style={STYLES.subtitle}><em>Coming soon</em></h4>
                  <p style={STYLES.subtitle}>Create re-usable components — from form controls to scrollers to complete design systems. Assemble the pieces into responsive stacks, grids, and screens, all powered by our dynamic layout engine.</p>
              </section>
              {/*<section id="drawingTools" ref={(el) => this.drawingTools = el} style={STYLES.pageSection}>
                  <h3 style={STYLES.h3}>Drawing Tools</h3>
                  <h4 style={STYLES.subtitle}><em>Coming soon</em></h4>
                  <p style={STYLES.subtitle}>Author every point and pixel of your designs with our built-in vector drawing tools.</p>
                </section>*/}
            </div>
          </div>
        </div>
      </div>

        <MobileContent />

      </div>

    )
  }

}

export default Radium(Features)



// WEBPACK FOOTER //
// ./src/pages/features.js